import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Collapse,
  CircularProgress,
  TextField as MuiTextField,
} from "@mui/material";
import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import FilterListIcon from "@mui/icons-material/FilterList";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Paper,
  Box,
  Stack,
  Autocomplete,
  CardHeader,
  IconButton,
} from "@mui/material";
import {
  Memory as MemoryIcon,
  PersonAdd as PersonAddIcon,
  MenuBook as MenuBookIcon,
  LocationOn as LocationOnIcon,
  Save as SaveIcon,
  DeleteForever as DeleteForeverIcon,
  Refresh as RefreshIcon,
  Info as InfoIcon,
  RssFeed as RssFeedIcon,
} from "@mui/icons-material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { ConfirmDialog } from "primereact/confirmdialog";
import HOST_URL from "../../../utils/Url";
import api from "../../../utils/Url";
import { getISTDate } from "../../../utils/Constant";
import ToastApp from "../../../ToastApp";
import { useUserId } from "../../../utils/Constant"; // Assuming path
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import { keyframes } from '@mui/system';
import moment from "moment";

// Assuming these types/utils are correctly defined in your project
// type Props = {};

const antennaOption = [
  { label: "Antenna 1", value: 1 },
  { label: "Antenna 2", value: 2 },
  { label: "Antenna 3", value: 3 },
  { label: "Antenna 4", value: 4 },
];

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(63, 81, 181, 0.4); }
  70% { box-shadow: 0 0 0 15px rgba(63, 81, 181, 0); }
  100% { box-shadow: 0 0 0 0 rgba(63, 81, 181, 0); }
`;
const FileAssigning = (/*props: Props*/) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { defaultValuestime } = getISTDate();

  // --- STATE MANAGEMENT ---
  const [dialogLocation, setDialogLocation] = useState<string | null>(null);
  const [dialogMemberCode, setDialogMemberCode] = useState<string | null>(null);
  const [dialogMemberOptions, setDialogMemberOptions] = useState<any>([]);
  const [membCode, setmembCode] = useState("");
  const [program, setProgram] = useState<string | null>(null);
  const [department1, setDepartment1] = useState<string | null>(null);
  const [category, setCategory] = useState<string | null>(null);
  const [programOptions, setProgramOptions] = useState<{ value: string, label: string }[]>([]);
  const [departmentOptions, setDepartmentOptions] = useState<{ value: string, label: string }[]>([]);
  const [categoryOptions, setCategoryOptions] = useState<{ value: string, label: string }[]>([]);
  const [userOptions, setUserOptions] = useState<{ value: string; label: string }[]>([]);

  const [openDialog, setOpenDialog] = useState<"books" | "locations" | "members" | null>(null);
  const [bookData, setBookData] = useState<any[]>([]);
  const [locationData, setLocationData] = useState<any[]>([]);
  const [memberData, setMemberData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [showMoreFilters, setShowMoreFilters] = useState(false);

  const [Userid, setUserId] = useUserId();
  // const [filters, setFilters] = useState({
  //   keyword: "",
  //   accNo: "",
  //   title: "",
  //   location: "",
  //   author: "",
  //   mem_cd: "",
  //   mem_ctgry: "",
  //   mem_inst: "",
  //   mem_dept: "",
  //   mem_degree: "",
  //   user: "",
  //   useR_ID: ""
  // });


  // Separate filter states for each dialog type
  const [bookFilters, setBookFilters] = useState({
    keyword: "",
    accNo: "",
    title: "",
    location: "",
    author: "",
    userId: "",
    fromDate :moment(new Date()).format('YYYY-MM-DD'),
    toDate:moment(new Date()).format('YYYY-MM-DD')
  });

  const [locationFilters, setLocationFilters] = useState({
    keyword: "",
    accNo: "",
    title: "",
    location: "",
    author: "",
    userId: "",
    fromDate :moment(new Date()).format('YYYY-MM-DD'),
    toDate:moment(new Date()).format('YYYY-MM-DD')
  });

  const [memberFilters, setMemberFilters] = useState({
    mem_cd: "",
    mem_ctgry: "",
    //  mem_inst: "",
    mem_dept: "",
    mem_degree: "",
    useR_ID: "",
    fromDate :moment(new Date()).format('YYYY-MM-DD'),
    toDate:moment(new Date()).format('YYYY-MM-DD')
  });


  const ResponsivePhotoModal = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'min(90vw, 90vh, 500px)',
    height: 'min(90vw, 90vh, 500px)',
    borderRadius: '50%',
    outline: 'none',
    animation: `${pulse} 2s infinite`,
    background: `
    radial-gradient(
      circle at 30% 30%,
      rgba(255,255,255,0.9) 0%,
      rgba(255,255,255,0.2) 50%,
      transparent 70%
    ),
    radial-gradient(
      circle at 70% 70%,
      rgba(255,255,255,0.7) 0%,
      transparent 60%
    ),
    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)
  `,
    padding: '8px',
    transition: 'all 0.3s ease',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: '50%',
      padding: '2px',
      background: 'linear-gradient(135deg, rgba(255,255,255,0.4), rgba(255,255,255,0))',
      WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      WebkitMaskComposite: 'xor',
      maskComposite: 'exclude',
    },
    [theme.breakpoints.down('sm')]: {
      width: '80vw',
      height: '80vw',
      background: `
      radial-gradient(
        circle at 30% 30%,
        rgba(255,255,255,0.8) 0%,
        rgba(255,255,255,0.1) 50%,
        transparent 70%
      ),
      linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)
    `,
    },
  }));

  const InnerPhotoCircle = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(0,0,0,0.05)',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(0.98)',
    },
    [theme.breakpoints.down('sm')]: {
      '&:hover': {
        transform: 'none', // Disable hover effect on mobile
      },
    },
  }));

  const CloseButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    backgroundColor: 'rgba(0,0,0,0.5)',
    color: 'white',
    zIndex: 1,
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.7)',
    },
  }));


  const [photoModalOpen, setPhotoModalOpen] = useState(false);
  const [selectedMemberPhoto, setSelectedMemberPhoto] = useState<string | null>(null);
  const [selectedMemberName, setSelectedMemberName] = useState("");

  const [epcnumber, setEpcNumber] = useState("");
  const [antina, setAntina] = useState<string>("1");
  const [macAddress, setMacAddress] = useState<string>("");
  const [antennaData, setAntennaData] = useState<any[]>([]);

  const [LocationOption, setLocOption] = useState([{ value: "-1", label: t("text.selectMapLoc") }]);
  const [memberOption, setMemberOption] = useState<any>([{ value: "-1", label: 'Select Member' }]);
  const [bookDetails, setBookDetails] = useState<any>([{ value: "-1", label: 'Select Book', author: "select" }]);

  const [termData, setTermData] = useState("");
  const [timerCheck, setTimerCheck] = useState<NodeJS.Timeout | null>(null);

  // Dashboard Stats
  const [totalAssignBook, setTotalAssignBook] = useState("0");
  const [totalAssignLocation, setTotalAssignLocation] = useState("0");
  const [totalAssignMember, setTotalAssignMember] = useState("0");

  // --- DATA FETCHING & SIDE EFFECTS ---
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await api.post('/AssigningRfid/GetUserName'); // Changed to POST
        if (response.data && response.data.data) {
          const transformedUsers = response.data.data.map((user: any) => ({
            value: user.useR_ID,
            label: user.logiN_NAME
          }));
          setUserOptions(transformedUsers);
        }
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    fetchUsers();

    getLocbyId("");
    getMacAddress();
    getHoardingData();
    fetchPrograms();
    fetchDepartments();
    fetchCategories();
  }, []);

  const getDialogMemb = async (nameData: string) => {
    if (!nameData || nameData.length < 2) {
      setDialogMemberOptions([]);
      return;
    }
    try {
      const res = await api.get(`AssigningRfid/GetMember?name=${nameData}`);
      const transformedData = res.data.map((item: any) => ({
        value: item.value,
        label: item.label,
      }));
      setDialogMemberOptions(transformedData);
    } catch (error) {
      console.error("Error fetching dialog members:", error);
      setDialogMemberOptions([]);
    }
  };

  const fetchPrograms = () => {
    const collectData = { branch_cd: "", branch_name: "" };
    api.post(`Member/Getm_prgram`, collectData)
      .then((response) => {
        if (response.data?.data) {
          setProgramOptions(response.data.data.map((item: any) => ({
            label: `${item.branch_name} (${item.branch_cd})`,
            value: item.branch_cd
          })));
        }
      })
      .catch((error) => {
        console.error("Error fetching programs:", error);
        setProgramOptions([]);
      });
  };

  // In your fetchDepartments function:
  const fetchDepartments = () => {
    const collectData = { fld_tag: "" };
    api.post(`Member/Getm_fcltydept`, collectData)
      .then((response) => {
        if (response.data?.data) {
          setDepartmentOptions(response.data.data.map((item: any) => ({
            label: item.fclty_dept_dscr, // Just the display name
            value: item.fclty_dept_dscr, // Using the description as value for filtering
            code: item.fclty_dept_cd // Keep the code if needed elsewhere
          })));
        }
      })
      .catch((error) => {
        console.error("Error fetching departments:", error);
        setDepartmentOptions([]);
      });
  };

  // In your fetchCategories function:
  const fetchCategories = () => {
    api.post(`Member/Getm_ctgry`, { ctgry_cd: "" })
      .then((response) => {
        if (response.data?.data) {
          setCategoryOptions(response.data.data.map((item: any) => ({
            label: item.ctgry_desc, // Just the display name
            value: item.ctgry_desc, // Using description as value for filtering
            code: item.ctgry_cd // Keep the code if needed elsewhere
          })));
        }
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
        setCategoryOptions([]);
      });
  };

  // Add these functions to your component
  const handleStatCardClick = async (type: "books" | "locations" | "members") => {
    setOpenDialog(type);
    setLoading(true);

    //const userDataString = localStorage.getItem('userdata');
    let userId = Userid

    try {
      // if (userDataString) {
      //   const parsedUserData = JSON.parse(userDataString);
      //   if (parsedUserData.userdetail && parsedUserData.userdetail.length > 0) {
      //     userId = parsedUserData.userdetail[0].useR_ID;
      //   }
      // }
    } catch (error) {
      console.error('Error parsing user data:', error);
    }

    try {
      if (type === "books") {
        const response = await api.get(`AssigningRfid/GetAssignBookAccDetails`, {
          params: { userId },
          headers: { keyword: bookFilters.keyword }
        });
        setBookData(response.data.data || []);
      } else if (type === "locations") {
        const response = await api.get(`AssigningRfid/GetAssignLocationBookAccDetails`, {
          params: { userId }
        });
        setLocationData(response.data.data || []);
      } else if (type === "members") {
        const response = await api.post(`Member/GetAssigned_member`, {
          mem_cd: memberFilters.mem_cd,
          mem_ctgry: memberFilters.mem_ctgry,
          //    mem_inst: memberFilters.mem_inst,
          mem_dept: memberFilters.mem_dept,
          mem_degree: memberFilters.mem_degree,
          useR_ID: memberFilters.useR_ID || userId,
          image: false,
            // fromDate: memberFilters.fromDate,
            // toDate: memberFilters.toDate
          // year: new Date().getFullYear()
        });
        setMemberData(response.data.data || []);
      }
    } catch (error) {
      console.error(`Error fetching ${type} data:`, error);
      toast.error(`Failed to load ${type} data`);
    } finally {
      setLoading(false);
    }
  };




  const handleBookFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setBookFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleLocationFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLocationFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleMemberFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setMemberFilters(prev => ({ ...prev, [name]: value }));
  };


  const handleSearch = async () => {
    setLoading(true);

    try {
      const userDataString = localStorage.getItem('userdata');
      let userId = Userid;

      // if (userDataString) {
      //   const parsedUserData = JSON.parse(userDataString);
      //   if (parsedUserData.userdetail && parsedUserData.userdetail.length > 0) {
      //     userId = parsedUserData.userdetail[0].useR_ID;
      //   }
      // }

      if (openDialog === "books") {
        const response = await api.get(`AssigningRfid/GetAssignBookAccDetails`, {
          params: {
            userId: bookFilters.userId || userId, // Use filtered user or fallback to current user
            maxRecords: 500,
            AccNo: bookFilters.accNo,
            Title: bookFilters.title,
            Location: bookFilters.location,
            Author: bookFilters.author,
            FromDate:bookFilters.fromDate,
            ToDate:bookFilters.toDate
          }
        });
        setBookData(response.data.data || []);
      } else if (openDialog === "locations") {
        const response = await api.get(`AssigningRfid/GetAssignLocationBookAccDetails`, {
          params: {
            userId: locationFilters.userId || userId, // Use filtered user or fallback to current user
            maxRecords: 500,
            AccNo: locationFilters.accNo,
            Title: locationFilters.title,
            Location: locationFilters.location,
            Author: locationFilters.author,
            FromDate:locationFilters.fromDate,
            ToDate:locationFilters.toDate

          }
        });
        setLocationData(response.data.data || []);
      } else if (openDialog === "members") {
        const response = await api.post(`Member/GetAssigned_member`, {
          mem_cd: memberFilters.mem_cd,
          mem_ctgry: category || "", // Now using the label directly
          mem_dept: department1 || "", // Now using the label directly
          mem_degree: program || "",
          useR_ID: memberFilters.useR_ID || userId,
          FromDate:memberFilters.fromDate,
          ToDate:memberFilters.toDate
        });
        setMemberData(response.data.data || []);
      }
    } catch (error) {
      console.error('Error searching:', error);
      toast.error('Search failed');
    } finally {
      setLoading(false);
    }
  };

  const handleResetFilters = async () => {
    if (openDialog === "books") {
      setBookFilters({
        keyword: "",
        accNo: "",
        title: "",
        location: "",
        author: "",
        userId: "",
        fromDate:"",
        toDate:""
      });
    } else if (openDialog === "locations") {
      setLocationFilters({
        keyword: "",
        accNo: "",
        title: "",
        location: "",
        author: "",
        userId: "",
        fromDate:moment(new Date()).format('YYYY-MM-DD'),
        toDate:moment(new Date()).format('YYYY-MM-DD'),
      });
    } else if (openDialog === "members") {
      setMemberFilters({
        mem_cd: "",
        mem_ctgry: "",
        //  mem_inst: "",
        mem_dept: "",
        mem_degree: "",
        useR_ID: "",
        fromDate:moment(new Date()).format('YYYY-MM-DD'),
        toDate:moment(new Date()).format('YYYY-MM-DD'),
      });
      setCategory(null);
      setDepartment1(null);
      setProgram(null);
      setDialogMemberCode(null); // Reset dialog member code
      setDialogMemberOptions([]); // Clear member options
    }

    setLoading(true);
    try {
      await handleStatCardClick(openDialog!);
    } finally {
      setLoading(false);
    }
  };


  const getIP = async () => {
    try {
      const response = await axios.get(`http://localhost:8080/api/Aratek/GetSystemIp?user=abc&pllas=xyz`);
      return response.data.data.ip;
    } catch (error) {
      console.error('Error fetching system IP:', error);
      toast.warn("Could not determine system IP. Using fallback.");
      return "127.0.0.1"; // Fallback IP
    }
  };

  const getHoardingData = () => {
    // let userId = "0"; // Default fallback

    try {
      //const userDataString = localStorage.getItem('userdata');

      // if (userDataString) {
      //   const parsedUserData = JSON.parse(userDataString);

      //   // Extract userId from nested structure
      //   if (parsedUserData?.userdetail?.length > 0) {
      //     userId = parsedUserData.userdetail[0].useR_ID || "0";
      //   }
      // }
    } catch (error) {
      console.error('Error parsing user data:', error);
      toast.error('Failed to parse user information');
    }

    // Use extracted userId in API call
    api.post(`AssigningRfid/CountTotAssign?userid=${Userid}`)
      .then((res) => {
        if (res.data.isSuccess && res.data.data.length > 0) {
          const { totalAssignBook, totalAssignLocation, totalAssignMember } = res.data.data[0];
          setTotalAssignBook(totalAssignBook);
          setTotalAssignLocation(totalAssignLocation);
          setTotalAssignMember(totalAssignMember);
        }
      })
      .catch((error) => {
        console.error('Error fetching assignment counts:', error);
        toast.error('Failed to load assignment statistics');
      });
  };



  const getMacAddress = () => {
    api.get(`AssigningRfid/GetMacAddress`)
      .then((res) => {
        setMacAddress(res.data);
        getAntennaPopulateResultTable(res.data);
      });
  };

  const getAntennaPopulateResultTable = (mac: any) => {
    api.get(`AssigningRfid/PopulateResultTable`, { params: { macAddress: mac } })
      .then((res) => {
        const data = res.data.map((item: any) => ({
          label: item.matchedAnt,
          value: item.antPower,
        }));
        setAntennaData(data);
      });
  };

  const getLocbyId = (name: string) => {
    api.post(`LocationItems/GetMappedLocation`, { id: -1, Location: name, modal: "" })
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({
          label: item.location,
          value: item.id,
        }));
        setLocOption(arr);
      });
  };

  const getMember = (nameData: string) => {
    if (nameData.length < 3) return;
    api.get(`AssigningRfid/GetMember?name=${nameData}`)
      .then((res) => setMemberOption(res.data));
  };

  const getBooks = (accNo: string) => {
    if (accNo.length < 1) return;
    api.get(`AssigningRfid/GetBookAccDetails`, { headers: { keyword: accNo } })
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({
          value: item.accNo,
          label: `${item.title} (${item.classNo})`,
          author: item.author,
          location: item.Location,
          locId: item.locId,
        }));
        setBookDetails(arr);
      });
  };

  // --- USER ACTIONS ---

  const handleGetEpc = async () => {
    if (!antina) {
      toast.error("Please select an antenna first.");
      return;
    }
    const systemIp = await getIP();
    const payload = { epc: "", antnum: antina, type: "Assign", systemip: systemIp };

    try {
      const response = await api.post(`AssigningRfid/GetRfid`, payload);
      if (response.data.isSuccess && response.data.data.length > 0) {
        const fetchedEpc = response.data.data[0]["epc"];
        setEpcNumber(fetchedEpc);
        toast.success(response?.data?.mesg);
      } else {
        setEpcNumber("");
        toast.error(response.data.mesg || "No RFID tag detected.");
      }
    } catch (error) {
      toast.error("An error occurred while fetching the EPC tag.");
      console.error(error);
    }
  };

  const handleResetAll = () => {
    setEpcNumber("");
    assignMemberFormik.resetForm();
    assignBookFormik.resetForm();
    assignLocationFormik.resetForm();
    setBookDetails([{ value: "-1", label: 'Select Book', author: "select" }]);
    setMemberOption([{ value: "-1", label: 'Select Member' }]);
    setDialogLocation(null); // Add this line
    getHoardingData();
    toast.info("Interface has been reset.");
  };

  // Debounced search handlers
  const handleMemberInputChange = (event: any, newInputValue: string) => {
    if (timerCheck) clearTimeout(timerCheck);
    const newTimer = setTimeout(() => getMember(newInputValue), 500);
    setTimerCheck(newTimer);
  };

  const handleBookInputChange = (event: any, newInputValue: string) => {
    if (timerCheck) clearTimeout(timerCheck);
    const newTimer = setTimeout(() => getBooks(newInputValue), 500);
    setTimerCheck(newTimer);
  };

  // --- FORMIK INSTANCES & VALIDATION ---

  const commonPayload = {
    rfid: epcnumber,
    macaddress: macAddress,
    umacaddress: macAddress, // Assuming same for update/delete
    cdate: defaultValuestime,
  };

  // 1. Member Assignment
  const assignMemberFormik = useFormik({
    initialValues: { mem_cd: "" },
    validationSchema: Yup.object({
      mem_cd: Yup.string().required('Member selection is required.'),
    }),
    onSubmit: async (values, { resetForm }) => {
      const payload = { ...values, ...commonPayload };
      const response = await api.post(`AssigningRfid/UpsertMemRfidBook`, payload);
      if (response.data.isSuccess) {
        toast.success(response.data.mesg);
        resetForm();
        getHoardingData(); // Refresh stats
      } else {
        toast.error(response.data.mesg);
      }
    },
  });

  const deleteMemberFormik = useFormik({
    initialValues: { mem_cd: "" },
    validationSchema: Yup.object({
      mem_cd: Yup.string().required('Member selection is required to delete assignment.'),
    }),
    onSubmit: async (values, { resetForm }) => {
      const payload = { ...values, ...commonPayload };
      const response = await api.post(`AssigningRfid/DeleteMemRfidlog`, payload);
      if (response.data.isSuccess) {
        toast.success(response.data.mesg);
        resetForm();
        getHoardingData();
      } else {
        toast.error(response.data.mesg);
      }
    },
  });

  // 2. Book Assignment
  const assignBookFormik = useFormik({
    initialValues: { p852: "", locationid: null },
    // validationSchema: Yup.object({
    //   p852: Yup.string().required('Book selection is required.'),
    //   locationid: Yup.string().required('Location ID is missing. Please re-select the book.'),
    // }),
    onSubmit: async (values) => {
      const payload = { ...values, ...commonPayload };
      const response = await api.post(`AssigningRfid/UpsertRfidBook`, payload);
      if (response.data.isSuccess) {
        toast.success(response.data.mesg);
        assignBookFormik.resetForm();
        getHoardingData();
      } else {
        toast.error(response.data.mesg);
      }
    },
  });

  const deleteBookFormik = useFormik({
    initialValues: { p852: "" },
    validationSchema: Yup.object({
      p852: Yup.string().required('Book selection is required to delete assignment.'),
    }),
    onSubmit: async (values, { resetForm }) => {
      const payload = { ...values, ...commonPayload };
      const response = await api.post(`AssigningRfid/DeleteBookRfidlog`, payload);
      if (response.data.isSuccess) {
        toast.success(response.data.mesg);
        resetForm();
        getHoardingData();
      } else {
        toast.error(response.data.mesg);
      }
    },
  });

  // 3. Location Assignment
  const assignLocationFormik = useFormik({
    initialValues: { Id: "" },
    validationSchema: Yup.object({
      Id: Yup.string().required('Location selection is required.'),
    }),
    onSubmit: async (values, { resetForm }) => {
      const payload = { Id: values.Id, LEPC: epcnumber };
      const response = await api.post(`AssigningRfid/UpsertLocationRfidlog`, payload);
      if (response.data.isSuccess) {
        toast.success(response.data.mesg);
        resetForm();
        getHoardingData();
      } else {
        toast.error(response.data.mesg);
      }
    },
  });

  const deleteLocationFormik = useFormik({
    initialValues: { Id: "" },
    validationSchema: Yup.object({
      Id: Yup.string().required('Location selection is required to delete assignment.'),
    }),
    onSubmit: async (values, { resetForm }) => {
      const payload = { Id: values.Id, LEPC: "" }; // Sending empty LEPC to delete
      const response = await api.post(`AssigningRfid/DeleteLocationRfidlog`, payload);
      if (response.data.isSuccess) {
        toast.success(response.data.mesg);
        resetForm();
        getHoardingData();
      } else {
        toast.error(response.data.mesg);
      }
    },
  });

  const StatCard = ({ icon, title, value, color, onClick }: any) => (
    <Grid item xs={12} sm={6} md={4}>
      <Paper
        elevation={3}
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          cursor: 'pointer',
          '&:hover': {
            boxShadow: 4,
            backgroundColor: `${color}.lighter`
          }
        }}
        onClick={onClick}
      >
        <Box sx={{ p: 1.5, borderRadius: '50%', backgroundColor: `${color}.light`, color: `${color}.dark` }}>
          {icon}
        </Box>
        <Box>
          <Typography variant="body2" color="text.secondary">{title}</Typography>
          <Typography variant="h5" fontWeight="bold">{value}</Typography>
        </Box>
      </Paper>
    </Grid>
  );

  return (

    <Box sx={{ p: 2, backgroundColor: '#f4f6f8', minHeight: '100vh' }}>
      <Modal
        open={photoModalOpen}
        onClose={() => setPhotoModalOpen(false)}
        aria-labelledby="member-photo-modal"
        aria-describedby="member-photo-modal-description"
        sx={{
          backdropFilter: 'blur(5px)',
        }}
      >
        <ResponsivePhotoModal>
          <CloseButton
            onClick={() => setPhotoModalOpen(false)}
            size="large"
            sx={{
              display: { xs: 'flex', sm: 'flex' } // Always show close button
            }}
          >
            <CloseIcon />
          </CloseButton>
          <InnerPhotoCircle>
            {selectedMemberPhoto ? (
              <img
                src={`data:image/jpeg;base64,${selectedMemberPhoto}`}
                alt="Member"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            ) : (
              <Avatar sx={{
                width: '60%',
                height: '60%',
                bgcolor: 'primary.main',
                '& svg': {
                  fontSize: { xs: '3rem', sm: '4rem', md: '5rem' }
                }
              }}>
                <PersonIcon fontSize="inherit" />
              </Avatar>
            )}
          </InnerPhotoCircle>
        </ResponsivePhotoModal>
      </Modal>

      <ConfirmDialog />
      <ToastApp />

      {/* --- Dashboard Stats --- */}

      <Grid container spacing={3} mb={3}>
        <StatCard
          icon={<MenuBookIcon />}
          title="Total Assigned Books"
          value={totalAssignBook}
          color="primary"
          onClick={() => handleStatCardClick("books")}
        />
        <StatCard
          icon={<LocationOnIcon />}
          title="Assigned Locations"
          value={totalAssignLocation}
          color="success"
          onClick={() => handleStatCardClick("locations")}
        />
        <StatCard
          icon={<PersonAddIcon />}
          title="Assigned Members"
          value={totalAssignMember}
          color="warning"
          onClick={() => handleStatCardClick("members")}
        />
      </Grid>


      {/* --- Main Control Panel --- */}
      <Card elevation={4} sx={{ mb: 3 }}>
        <CardHeader
          title="RFID Tag Control Panel"
          subheader="Scan a tag to begin assignment"
          action={
            <IconButton onClick={handleResetAll} title="Reset Interface">
              <RefreshIcon />
            </IconButton>
          }
        />
        <Divider />
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <Typography variant="body1" component="div" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <MemoryIcon color="action" /> <strong>MAC Address:</strong> {macAddress || "Loading..."}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Autocomplete
                options={antennaData.length > 0 ? antennaData : antennaOption}
                defaultValue={antennaOption[0]}
                getOptionLabel={(option) => option.label}
                fullWidth
                size="small"
                onChange={(event, newValue) => setAntina(newValue?.value.toString() || "1")}
                renderInput={(params) => <TextField {...params} label="Select Antenna" />}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Button
                fullWidth
                variant="contained"
                startIcon={<RssFeedIcon />}
                onClick={handleGetEpc}
                size="large"
              >
                Get EPC Tag
              </Button>
            </Grid>
          </Grid>
          {epcnumber && (
            <Box sx={{ mt: 3, p: 2, backgroundColor: 'primary.lighter', border: 1, borderColor: 'primary.light', borderRadius: 1 }}>
              <Typography variant="h6" component="div" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <InfoIcon color="primary" /> Active EPC Tag: <Typography component="span" fontWeight="bold" color="primary.dark">{epcnumber}</Typography>
              </Typography>
            </Box>
          )}
        </CardContent>
      </Card>

      {/* --- Action Cards --- */}
      <Grid container spacing={3}>
        {/* Member Assignment Card */}
        <Grid item xs={12} md={6} lg={4}>
          <Card elevation={2} >
            <CardHeader avatar={<PersonAddIcon />} title="Assign to Member" />
            <Divider />
            <CardContent>
              <Autocomplete
                options={memberOption}
                fullWidth
                size="small"
                onInputChange={handleMemberInputChange}
                onChange={(e, nv: any) => {
                  const memCd = nv?.value || "";
                  assignMemberFormik.setFieldValue("mem_cd", memCd);
                  deleteMemberFormik.setFieldValue("mem_cd", memCd);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search and Select Member"
                    error={assignMemberFormik.touched.mem_cd && Boolean(assignMemberFormik.errors.mem_cd)}
                    helperText={assignMemberFormik.touched.mem_cd && assignMemberFormik.errors.mem_cd}
                  />
                )}
              />
              <Stack direction="row" spacing={2} mt={2}>
                <Button fullWidth variant="contained" color="success" startIcon={<SaveIcon />} onClick={() => assignMemberFormik.handleSubmit()}>Assign</Button>
                <Button fullWidth variant="outlined" color="error" startIcon={<DeleteForeverIcon />} onClick={() => deleteMemberFormik.handleSubmit()}>Delete</Button>
              </Stack>
            </CardContent>
          </Card>
        </Grid>



        {/* Book Assignment Card */}
        <Grid item xs={12} md={6} lg={4}>
          <Card elevation={2} >
            <CardHeader avatar={<MenuBookIcon />} title="Assign to Book" />
            <Divider />
            <CardContent>
              <Autocomplete
                options={bookDetails}
                getOptionLabel={(opt: any) => `${opt.value} - ${opt.label}`}
                fullWidth
                size="small"
                onInputChange={handleBookInputChange}
                onChange={(e, nv) => {
                  const p852 = nv?.value || "";
                  const locId = nv?.locId || null;
                  assignBookFormik.setFieldValue("p852", p852);
                  assignBookFormik.setFieldValue("locationid", locId);
                  deleteBookFormik.setFieldValue("p852", p852);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Book by Accession No."
                    error={assignBookFormik.touched.p852 && Boolean(assignBookFormik.errors.p852)}
                    helperText={assignBookFormik.touched.p852 && assignBookFormik.errors.p852}
                  />
                )}
              />
              <Stack direction="row" spacing={2} mt={2}>
                <Button fullWidth variant="contained" color="success" startIcon={<SaveIcon />} onClick={() => assignBookFormik.handleSubmit()}>Assign</Button>
                <Button fullWidth variant="outlined" color="error" startIcon={<DeleteForeverIcon />} onClick={() => deleteBookFormik.handleSubmit()}>Delete</Button>
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        {/* Location Assignment Card */}
        <Grid item xs={12} md={6} lg={4}>
          <Card elevation={2} >
            <CardHeader avatar={<LocationOnIcon />} title="Assign to Location" />
            <Divider />
            <CardContent>
              <Autocomplete
                options={LocationOption}
                fullWidth
                size="small"
                value={LocationOption.find((option: any) => option?.value === assignBookFormik.values.locationid) || null}
                onInputChange={(e, nv) => { if (nv?.length > 3) getLocbyId(nv) }}
                onChange={(e, nv: any) => {
                  const locId = nv?.value || "";
                  assignLocationFormik.setFieldValue("Id", locId);
                  deleteLocationFormik.setFieldValue("Id", locId);
                  assignBookFormik.setFieldValue("locationid", locId);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search and Select Location"
                  // error={assignLocationFormik.touched.Id && Boolean(assignLocationFormik.errors.Id)}
                  // helperText={assignLocationFormik.touched.Id && assignLocationFormik.errors.Id}
                  />
                )}
              />
              <Stack direction="row" spacing={2} mt={2}>
                <Button fullWidth variant="contained" color="success" startIcon={<SaveIcon />} onClick={() => assignLocationFormik.handleSubmit()}>Assign</Button>
                <Button fullWidth variant="outlined" color="error" startIcon={<DeleteForeverIcon />} onClick={() => deleteLocationFormik.handleSubmit()}>Delete</Button>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Books Dialog */}
      <Dialog
        fullWidth
        maxWidth="lg"
        open={openDialog === "books"}
        onClose={() => {
          if (!loading) {
            setOpenDialog(null);
            setBookFilters({
              keyword: "",
              accNo: "",
              title: "",
              location: "",
              author: "",
              userId: "",
              fromDate:"",
              toDate:""
            });
            setDialogLocation(null);

          }
        }}
      >
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span>Assigned Books</span>
          <Box>

            <Button
              variant="contained"
              size="small"
              onClick={() => !loading && setOpenDialog(null)} // Prevent closing while loading
              sx={{
                backgroundColor: 'white',
                color: 'primary.main',
                '&:hover': { backgroundColor: 'grey.100' }
              }}
              disabled={loading} // Disable while loading
            >
              <CloseIcon />
            </Button>
          </Box>
        </DialogTitle>

        <DialogContent dividers>
          <form onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
          }}>
            {/* Your filter inputs */}
            <Grid container spacing={2} sx={{ mb: 2 }} alignItems="center">
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={bookDetails}
                  getOptionLabel={(opt: any) => `${opt.value} - ${opt.label}`}
                  fullWidth
                  size="small"
                  onInputChange={handleBookInputChange}
                  onChange={(e, nv) => {
                    const p852 = nv?.value || "";
                    const locId = nv?.locId || null;
                    assignBookFormik.setFieldValue("p852", p852);
                    //   assignBookFormik.setFieldValue("locationid", locId);
                    deleteBookFormik.setFieldValue("p852", p852);

                    // Update the book filters and trigger search
                    setBookFilters(prev => ({
                      ...prev,
                      accNo: p852,
                      location: nv?.location || ""
                    }));
                    // handleSearch();
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search Book by Accession No."
                      error={assignBookFormik.touched.p852 && Boolean(assignBookFormik.errors.p852)}
                      helperText={assignBookFormik.touched.p852 && assignBookFormik.errors.p852}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <MuiTextField
                  name="title"
                  label="Title"
                  value={bookFilters.title}
                  onChange={handleBookFilterChange}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={LocationOption}
                  fullWidth
                  size="small"
                  value={LocationOption.find((option: any) => option?.value === dialogLocation) || null}
                  onInputChange={(e, nv) => {
                    if (nv?.length > 3) getLocbyId(nv);
                  }}
                  onChange={(e, nv: any) => {
                    const locId = nv?.value || "";
                    const locationName = nv?.label || "";
                    setDialogLocation(locId);

                    // Update the filters
                    if (openDialog === "books") {
                      setBookFilters(prev => ({
                        ...prev,
                        location: locationName
                      }));
                    } else if (openDialog === "locations") {
                      setLocationFilters(prev => ({
                        ...prev,
                        location: locationName
                      }));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search and Select Location"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <MuiTextField
                  name="author"
                  label="Author"
                  value={bookFilters.author}
                  onChange={handleBookFilterChange}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={userOptions}
                  getOptionLabel={(option) => option.label}
                  value={userOptions.find(user => user.value === bookFilters.userId) || null}
                  onChange={(event, newValue) => {
                    setBookFilters(prev => ({
                      ...prev,
                      userId: newValue ? newValue.value : ""
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Select User" />
                  )}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  type="date"
                  label="FromDate"
                  onChange={(event:any) => {
                    setBookFilters(prev => ({
                      ...prev,
                      fromDate : event.target.value
                    }));
                  }}
                  InputLabelProps={{shrink:true}}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  type="date"
                  label="To Date"
                  onChange={(event:any) => {
                    setBookFilters(prev => ({
                      ...prev,
                      toDate : event.target.value
                    }));
                  }}
                  InputLabelProps={{shrink:true}}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  size="small"
                  sx={{ height: '40px' }}
                  disabled={loading}
                >
                  {loading ? <CircularProgress size={20} /> : 'Search'}
                </Button>
              </Grid>
              {/* <Grid item xs={12} sm={3}>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={handleResetFilters}
                  size="small"
                  sx={{ height: '40px' }}
                >
                  Reset
                </Button>
              </Grid> */}
            </Grid>
          </form>

          {/* DataGrid with loading overlay */}
          <Box sx={{ position: 'relative', height: 500 }}>
            {loading && (
              <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1
              }}>
                <CircularProgress />
              </Box>
            )}

            {bookData.length > 0 ? (
              <DataGrid
                rows={bookData.map((item, index) => ({
                  ...item,
                  id: index,
                  srNo: index + 1,
                  user: item.user || "admin"
                }))}
                columns={[
                  { field: 'srNo', headerName: 'Sr. No.', width: 80 },
                  { field: 'accNo', headerName: 'Accession No.', width: 150 },
                  { field: 'title', headerName: 'Title', width: 250 },
                  { field: 'author', headerName: 'Author', width: 200 },
                  { field: 'location', headerName: 'Location', width: 200 },
                  { field: 'classNo', headerName: 'Class No.', width: 120 },
                  { field: 'user', headerName: 'User', width: 120 },
                ]}
                loading={loading} // Use DataGrid's built-in loading prop
                sx={{
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: 'primary.light',
                    color: 'white'
                  }
                }}
              />
            ) : (
              <Box sx={{
                p: 4,
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                height: '100%',
                justifyContent: 'center'
              }}>
                <MenuBookIcon color="action" sx={{ fontSize: 48 }} />
                <Typography variant="h6">No assigned books found</Typography>
                <Typography variant="body2" color="text.secondary">
                  Try adjusting your search filters
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>
      {/* Locations Dialog */}
      <Dialog
        fullWidth
        maxWidth="lg"
        open={openDialog === "locations"}
        onClose={() => {
          if (!loading) {
            setOpenDialog(null);
            setLocationFilters({
              keyword: "",
              accNo: "",
              title: "",
              location: "",
              author: "",
              userId: "",
              fromDate:moment(new Date()).format('YYYY-MM-DD'),
              toDate:moment(new Date()).format('YYYY-MM-DD'),
            });
            setDialogLocation(null); // Add this line
          }
        }}
      >
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span>Assigned Locations</span>
          <Box>

            <Button
              variant="contained"
              size="small"
              onClick={() => !loading && setOpenDialog(null)} // Prevent closing while loading
              sx={{
                backgroundColor: 'white',
                color: 'primary.main',
                '&:hover': { backgroundColor: 'grey.100' }
              }}
              disabled={loading} // Disable while loading
            >
              <CloseIcon />
            </Button>
          </Box>
        </DialogTitle>

        <DialogContent dividers>
          <form onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
          }}>
            <Grid container spacing={2} sx={{ mb: 2 }} alignItems="center">
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={bookDetails}
                  getOptionLabel={(opt: any) => `${opt.value} - ${opt.label}`}
                  fullWidth
                  size="small"
                  onInputChange={handleBookInputChange}
                  onChange={(e, nv) => {
                    const p852 = nv?.value || "";
                    const locId = nv?.locId || null;
                    assignBookFormik.setFieldValue("p852", p852);
                    //  assignBookFormik.setFieldValue("locationid", locId);
                    deleteBookFormik.setFieldValue("p852", p852);

                    // Update the location filters and trigger search
                    setLocationFilters(prev => ({
                      ...prev,
                      accNo: p852,
                      location: nv?.location || ""
                    }));
                    // handleSearch();
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search Book by Accession No."
                      error={assignBookFormik.touched.p852 && Boolean(assignBookFormik.errors.p852)}
                      helperText={assignBookFormik.touched.p852 && assignBookFormik.errors.p852}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <MuiTextField
                  name="title"
                  label="Title"
                  value={locationFilters.title}
                  onChange={handleLocationFilterChange}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={LocationOption}
                  fullWidth
                  size="small"
                  value={LocationOption.find((option: any) => option?.value === dialogLocation) || null}
                  onInputChange={(e, nv) => {
                    if (nv?.length > 3) getLocbyId(nv);
                  }}
                  onChange={(e, nv: any) => {
                    const locId = nv?.value || "";
                    const locationName = nv?.label || "";
                    setDialogLocation(locId);

                    // Update the filters
                    if (openDialog === "books") {
                      setBookFilters(prev => ({
                        ...prev,
                        location: locationName
                      }));
                    } else if (openDialog === "locations") {
                      setLocationFilters(prev => ({
                        ...prev,
                        location: locationName
                      }));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search and Select Location"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <MuiTextField
                  name="author"
                  label="Author"
                  value={locationFilters.author}
                  onChange={handleLocationFilterChange}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={userOptions}
                  getOptionLabel={(option) => option.label}
                  value={userOptions.find(user => user.value === locationFilters.userId) || null}
                  onChange={(event, newValue) => {
                    setLocationFilters(prev => ({
                      ...prev,
                      userId: newValue ? newValue.value : ""
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Select User" />
                  )}
                  fullWidth
                  size="small"
                />
              </Grid>


              <Grid item xs={12} sm={3}>
                <TextField
                  type="date"
                  label="FromDate"
                  onChange={(event:any) => {
                    setLocationFilters(prev => ({
                      ...prev,
                      fromDate : event.target.value
                    }));
                  }}
                  InputLabelProps={{shrink:true}}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  type="date"
                  label="To Date"
                  onChange={(event:any) => {
                    setLocationFilters(prev => ({
                      ...prev,
                      toDate : event.target.value
                    }));
                  }}
                  InputLabelProps={{shrink:true}}
                  fullWidth
                  size="small"
                />
              </Grid>


              


              <Grid item xs={12} sm={3}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  size="small"
                  sx={{ height: '40px' }}
                  disabled={loading}
                >
                  {loading ? <CircularProgress size={20} /> : 'Search'}
                </Button>
              </Grid>

            </Grid>
          </form>


          <Box sx={{ position: 'relative', height: 500 }}>
            {loading && (
              <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1
              }}>
                <CircularProgress />
              </Box>
            )}
            {locationData.length > 0 ? (
              <DataGrid
                rows={locationData.map((item, index) => ({
                  ...item,
                  id: index,
                  srNo: index + 1,
                  user: item.user || "admin"
                }))}
                columns={[
                  { field: 'srNo', headerName: 'Sr. No.', width: 80 },
                  { field: 'accNo', headerName: 'Accession No.', width: 150 },
                  { field: 'title', headerName: 'Title', width: 250 },
                  { field: 'author', headerName: 'Author', width: 200 },
                  { field: 'location', headerName: 'Location', width: 200 },
                  { field: 'classNo', headerName: 'Class No.', width: 120 },
                  { field: 'user', headerName: 'User', width: 120 },
                ]}
                loading={loading} // Use DataGrid's built-in loading prop
                sx={{
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: 'primary.light',
                    color: 'white'
                  }
                }}
              />
            ) : (
              <Box sx={{
                p: 4,
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                height: '100%',
                justifyContent: 'center'
              }}>
                <MenuBookIcon color="action" sx={{ fontSize: 48 }} />
                <Typography variant="h6">No assigned location found</Typography>
                <Typography variant="body2" color="text.secondary">
                  Try adjusting your search filters
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>
      {/* Members Dialog */}
      <Dialog
        fullWidth
        maxWidth="lg"
        open={openDialog === "members"}
        onClose={() => {
          if (!loading) {
            setOpenDialog(null);
            setMemberFilters({
              mem_cd: "",
              mem_ctgry: "",
              //  mem_inst: "",
              mem_dept: "",
              mem_degree: "",
              useR_ID: "",
              fromDate :moment(new Date()).format('YYYY-MM-DD'),
              toDate:moment(new Date()).format('YYYY-MM-DD')
            });
            setCategory(null);
            setDepartment1(null);
            setProgram(null);
            setDialogMemberCode(null);
            setDialogMemberOptions([]);
            setPhotoModalOpen(false); // Close photo modal if open
          }
        }}

      >
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span>Assigned Members</span>
          <Box>

            <Button
              variant="contained"
              size="small"
              onClick={() => !loading && setOpenDialog(null)} // Prevent closing while loading
              sx={{
                backgroundColor: 'white',
                color: 'primary.main',
                '&:hover': { backgroundColor: 'grey.100' }
              }}
              disabled={loading} // Disable while loading
            >
              <CloseIcon />
            </Button>
          </Box>
        </DialogTitle>

        <DialogContent dividers>
          <form onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
          }}>
            <Grid container spacing={2} sx={{ mb: 2 }} alignItems="center">


              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={dialogMemberOptions}
                  getOptionLabel={(option: any) => option.label || ""}
                  fullWidth
                  size="small"
                  onInputChange={(event, newInputValue) => {
                    getDialogMemb(newInputValue);
                  }}
                  onChange={(event, newValue) => {
                    setDialogMemberCode(newValue ? newValue.value : null);
                    setMemberFilters(prev => ({ ...prev, mem_cd: newValue ? newValue.value : "" }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Member Code" />
                  )}
                />
              </Grid>
                 {/* Category Filter */}
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={categoryOptions}
                  getOptionLabel={(option) => option.label}
                  value={categoryOptions.find(opt => opt.value === category) || null}
                  onChange={(event, newValue) => {
                    setCategory(newValue ? newValue.value : null);
                    setMemberFilters(prev => ({
                      ...prev,
                      mem_ctgry: newValue ? newValue.value : ""
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Category" />
                  )}
                  fullWidth
                  size="small"
                />
              </Grid>

              {/* Department Filter */}
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={departmentOptions}
                  getOptionLabel={(option) => option.label}
                  value={departmentOptions.find(opt => opt.value === department1) || null}
                  onChange={(event, newValue) => {
                    setDepartment1(newValue ? newValue.value : null);
                    setMemberFilters(prev => ({
                      ...prev,
                      mem_dept: newValue ? newValue.value : ""
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Department" />
                  )}
                  fullWidth
                  size="small"
                />
              </Grid>

           
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={programOptions}
                  getOptionLabel={(option) => option.label}
                  value={programOptions.find(opt => opt.value === program) || null}
                  onChange={(event, newValue) => {
                    setProgram(newValue ? newValue.value : null);
                    setMemberFilters(prev => ({ ...prev, mem_degree: newValue ? newValue.value : "" }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Program" />
                  )}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={userOptions}
                  getOptionLabel={(option) => option.label}
                  value={userOptions.find(user => user.value === memberFilters.useR_ID) || null}
                  onChange={(event, newValue) => {
                    setMemberFilters(prev => ({
                      ...prev,
                      useR_ID: newValue ? newValue.value : ""
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Select User" />
                  )}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  type="date"
                  label="FromDate"
                  onChange={(event:any) => {
                    setMemberFilters(prev => ({
                      ...prev,
                      fromDate : event.target.value
                    }));
                  }}
                  InputLabelProps={{shrink:true}}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  type="date"
                  label="To Date"
                  onChange={(event:any) => {
                    setMemberFilters(prev => ({
                      ...prev,
                      toDate : event.target.value
                    }));
                  }}
                  InputLabelProps={{shrink:true}}
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  size="small"
                  sx={{ height: '40px' }}
                  disabled={loading}
                >
                  {loading ? <CircularProgress size={20} /> : 'Search'}
                </Button>
              </Grid>

            </Grid>
          </form>

          <Box sx={{ position: 'relative', height: 500 }}>
            {loading && (
              <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1
              }}>
                <CircularProgress />
              </Box>
            )}
            {memberData.length > 0 ? (
              <DataGrid
                rows={memberData.map((item, index) => ({
                  ...item,
                  id: index,
                  srNo: index + 1,
                  user: item.user || "admin",
                  name: `${item.mem_firstnm} ${item.mem_mname || ''} ${item.mem_lstnm || ''}`.trim(),
                }))}
                columns={[
                  { field: 'srNo', headerName: 'Sr. No.', width: 80 },
                  {
                    field: 'mname',
                    headerName: 'Member Name',
                    width: 200,
                    renderCell: (params) => (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          cursor: 'pointer',
                          '&:active': {
                            transform: 'scale(0.95)',
                          }
                        }}
                        onClick={() => {
                          setSelectedMemberPhoto(params.row.member_photo);
                          setPhotoModalOpen(true);
                        }}
                      >
                        <Avatar
                          sx={{
                            width: 32,
                            height: 32,
                            transition: 'transform 0.2s',
                            '&:hover': {
                              transform: 'scale(1.1)'
                            },
                            '@media (hover: none)': {
                              '&:hover': {
                                transform: 'none' // Disable hover effect on touch devices
                              }
                            }
                          }}
                          src={params.row.member_photo ? `data:image/jpeg;base64,${params.row.member_photo}` : undefined}
                        >
                          {!params.row.member_photo && <PersonIcon />}
                        </Avatar>
                        {params.value}
                      </Box>
                    )
                  },
                  { field: 'mem_cd', headerName: 'Member Code', width: 150 },

                  { field: 'mobileNo', headerName: 'Contact No.', width: 150 },
                  { field: 'mem_ctgry', headerName: 'Category', width: 150 },
                  { field: 'mem_dept', headerName: 'Department', width: 150 },
                  { field: 'mem_degree', headerName: 'Program', width: 150 },
                  { field: 'user', headerName: 'User', width: 120 },
                ]}
                loading={loading}
                sx={{
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: 'primary.light',
                    color: 'white'
                  }
                }}
              />
            ) : (
              <Box sx={{
                p: 4,
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                height: '100%',
                justifyContent: 'center'
              }}>
                <MenuBookIcon color="action" sx={{ fontSize: 48 }} />
                <Typography variant="h6">No assigned books found</Typography>
                <Typography variant="body2" color="text.secondary">
                  Try adjusting your members filters
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>

      {/* Photo Modal */}
      {/* <Dialog
        open={photoModalOpen}
        onClose={() => setPhotoModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span>{selectedMemberName}'s Profile</span>
          <IconButton onClick={() => setPhotoModalOpen(false)} sx={{ color: 'white' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
          backgroundColor: '#f5f5f5'
        }}>
          {selectedMemberPhoto ? (
            <img
              src={`data:image/jpeg;base64,${selectedMemberPhoto}`}
              alt="Member"
              style={{
                maxWidth: '100%',
                maxHeight: '80vh',
                borderRadius: '4px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
              }}
            />
          ) : (
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2
            }}>
              <Avatar sx={{ width: 120, height: 120, fontSize: 60 }}>
                <PersonIcon fontSize="inherit" />
              </Avatar>
              <Typography variant="h6" color="text.secondary">
                No photo available
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ backgroundColor: '#f5f5f5' }}>
          <Button
            onClick={() => setPhotoModalOpen(false)}
            variant="contained"
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog> */}
    </Box>
  );
};

export default FileAssigning;
